import React, { useState } from 'react';
import SettingsPanel from './SettingsPanel';
import { Link/*, useLocation*/ } from 'react-router-dom';
import CosmosLogosCheck from './CosmosLogosCheck';
import AthenaCheck from './AthenaCheck';
import OlympusGridCheck from './OlympusGrid';
import AthenaDrawer from './AthenaDrawer';

const Home: React.FC = () => {
  //const location = useLocation();
  const [showMenu, setShowMenu] = useState<boolean>(false);

  return (
    <main className="odyssey-press-home" style={{ position: 'relative' }}>
      {/* Settings Menu */}
      <div style={{ position: 'fixed', top: 16, right: 16, zIndex: 1000 }}>
        <button
          onClick={() => setShowMenu(!showMenu)}
          style={{
            background: '#222',
            color: '#ffdd80',
            border: '1px solid #444',
            borderRadius: '6px',
            padding: '0.5rem 1rem',
            fontSize: '1.2rem',
            cursor: 'pointer',
          }}
        >
          ☰
        </button>
      </div>

      {showMenu && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            height: '100vh',
            width: '320px',
            backgroundColor: '#1a1a1a',
            color: '#fff',
            borderLeft: '1px solid #444',
            padding: '1rem',
            zIndex: 999,
            overflowY: 'auto',
          }}
        >
          <h3 style={{ color: '#ffdd80' }}>Menu</h3>
          <SettingsPanel />
        </div>
      )}

      {/* Hero Section */}
      <div className="hero">
        <h1>
          ✨ <span className="brand">Odyssey-Press</span>
        </h1>
        <p className="tagline">The Serverless AI Publishing Engine of the New Age</p>

        <blockquote>
          “An AI-assisted writing engine for prophets, rebels, and storytellers who refuse to die
          unwritten.”
        </blockquote>

        <p>
          Explore the writings of <strong>@alchemisthomer</strong> streamed from the{' '}
          <em>Odyssey of Christ</em> series.
        </p>

        <div className="links">
          <a
            className="button"
            href="https://github.com/alchemisthomer/odyssey-press"
            target="_blank"
            rel="noopener noreferrer"
          >
            📜 View the Source on GitHub
          </a>

          <Link to="/writings" className="button primary">
            📚 Browse All Writings
          </Link>
        </div>
      </div>

      {/* Checks */}
      <CosmosLogosCheck />
      <AthenaCheck />
      <OlympusGridCheck />
      <AthenaDrawer />

    </main>
  );
};

export default Home;
